import { request } from '../request';

/**
 * GET 获取我的企业认证与企业入驻申请
 *
 * HTTP 接口: GET /enterprise-market-onboarding
 * 说明: 用于获取当前登录账号的企业认证申请、企业风采图片、服务商资料及入驻状态。
 *
 * @returns {Promise<Api.EnterpriseOnboarding.ResidencyDetailResponse>} 返回企业入驻与认证综合详情数据 (partydto.ResidencyDetailResponse)
 */
export function fetchGetEnterpriseMarketOnboarding() {
  return request<Api.EnterpriseOnboarding.ResidencyDetailResponse>({
    url: '/enterprise-market-onboarding',
    method: 'get',
  });
}

/**
 * POST 提交企业认证与企业入驻申请
 *
 * HTTP 接口: POST /enterprise-market-onboarding
 * 说明: 提交企业的名称、社会信用代码、法定代表人信息、运营人员联系方式、营业执照及授权委托书文件、企业图片和服务商资料。
 *
 * @param {Api.EnterpriseOnboarding.SubmitEnterpriseMarketOnboardingRequest} data 提交企业认证与企业入驻申请请求参数 (partydto.SubmitEnterpriseMarketOnboardingRequest)
 * @returns {Promise<Api.EnterpriseOnboarding.ResidencyDetailResponse>} 返回提交结果及最新的综合详情数据 (partydto.ResidencyDetailResponse)
 */
export function fetchSubmitEnterpriseMarketOnboarding(
  data: Api.EnterpriseOnboarding.SubmitEnterpriseMarketOnboardingRequest
) {
  return request<Api.EnterpriseOnboarding.ResidencyDetailResponse>({
    url: '/enterprise-market-onboarding',
    method: 'post',
    data,
  });
}

/**
 * GET 获取我的企业入驻状态
 *
 * HTTP 接口: GET /market-residency
 * 说明: 查询当前账号在市场的入驻状态（如 PENDING 审核中、APPROVED 已通过、REJECTED 已驳回等）。
 *
 * @returns {Promise<Api.EnterpriseOnboarding.ResidencyResponse>} 返回企业入驻状态信息 (partydto.ResidencyResponse)
 */
export function fetchGetMarketResidency() {
  return request<Api.EnterpriseOnboarding.ResidencyResponse>({
    url: '/market-residency',
    method: 'get',
  });
}

/**
 * POST 提交企业入驻申请
 *
 * HTTP 接口: POST /market-residency
 * 说明: 提交企业市场的单独入驻申请。
 *
 * @param {Api.EnterpriseOnboarding.SubmitMarketResidencyRequest} [data] 提交企业入驻申请请求参数（可选）
 * @returns {Promise<Api.EnterpriseOnboarding.ResidencyResponse>} 返回企业入驻申请结果及状态 (partydto.ResidencyResponse)
 */
export function fetchSubmitMarketResidency(
  data?: Api.EnterpriseOnboarding.SubmitMarketResidencyRequest
) {
  return request<Api.EnterpriseOnboarding.ResidencyResponse>({
    url: '/market-residency',
    method: 'post',
    data,
  });
}
